import axios from 'axios';
import Auth from '../auth/Auth.js';
import l from '../lang/Translation.js'


var apiClient = function(clientId, clientSecret) {
    let client = axios.create();

    let login = async function(username, password) {
        return new Promise((resolve, reject) => {
            client.post('/api/auth/login', {
                username: username,
                password: password,
                grant_type: 'password',
                client_id: clientId,
                client_secret: clientSecret
            }).then((response) => {
                Auth.setAccessToken(response.data.access_token)
                Auth.setRefreshToken(response.data.refresh_token)
                Auth.setAccessTokenExpiresIn(response.data.expires_in)
                resolve(response)
            }).catch((e) => {
                if (e.response.data.error) {
                    console.log(l.t(e.response.data.error))
                    reject(l.t(e.response.data.error))
                }
                reject('something_went_wrong')
            });
        })
    }
    // Assign the login functionality to the client
    client.login = login

    let refreshAccessToken = async function() {
        return new Promise((resolve, reject) => {
            client.post('/api/auth/login', {
                grant_type: 'refresh_token',
                refresh_token: Auth.getRefreshToken(),
                client_id: clientId,
                client_secret: clientSecret
            }).then((response) => {
                Auth.setAccessToken(response.data.access_token)
                Auth.setRefreshToken(response.data.refresh_token)
                Auth.setAccessTokenExpiresIn(response.data.expires_in)
                resolve(response.data.access_token)
            }).catch((e) => {
                if (e.response.data.error) {
                    console.log(l.t(e.response.data.error))
                    reject(l.t(e.response.data.error))
                }
                reject('something_went_wrong')
            });
        })
    }

    // Attach bearer token when possible
    client.interceptors.request.use (
        async config => {
            var accessToken = Auth.getAccessToken()
            if (accessToken) {
                // Check if it is expired:
                if (Auth.isRefreshNeeded()) {
                    // It expired or is about to expire (in 5 seconds), try refreshing the token first
                    // Unset the access token, to not end up in an infinite loop
                    Auth.setAccessToken(null);
                    // Refresh
                    await refreshAccessToken()
                    // Override the token now that it's refreshed:
                    accessToken = Auth.getAccessToken()
                }
                // console.log('Set access token in the header')
                config.headers = {
                    'Authorization': 'Bearer ' + accessToken
                }
            }
            config.url = process.env.VUE_APP_API_URL + config.url
            return config;
        },
        error => {
            Promise.reject(error)
        }
    )
    
    // Expose this client
    return client
}

export default apiClient